import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import CircularProgressLoader from '../../components/CircularProgressLoader';

const FULL_SIZE_IFRAME_STYLE = { width: '100%', height: '100%', flex: 1, alignSelf: 'stretch', border: 'none' };

// Generic viewer for a DRAWER_MENU_LIST item's "value": renders it as an iframe when it's a
// URL, otherwise as raw HTML content.
const DrawerMenuContentPage = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { content, title } = location.state || {};
    const [loading, setLoading] = useState(true);
    const isUrl = content?.startsWith('https');
    const hideLoaderOnLoad = () => setLoading(false);

    useEffect(() => {
        if (!isUrl) {
            setLoading(false);
        }
    }, [isUrl]);

    return (
        <Box className="drawer-menu-content-page">
            <Box className="main-container">
                <Box className="main">
                    {loading && <CircularProgressLoader message={t('pleaseWaitText')} />}
                    {isUrl ? (
                        <iframe src={content} title={title} style={FULL_SIZE_IFRAME_STYLE} onLoad={hideLoaderOnLoad} />
                    ) : (
                        <Box dangerouslySetInnerHTML={{ __html: content }} />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default DrawerMenuContentPage;
